import { store } from "@/store/store";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import { alegacion } from "@/shared/dtos/alegacion";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { alegacion_historico } from "@/shared/dtos/alegacion_historico";
import { fichajes_empleado_historial } from "@/shared/dtos/fichajes_empleado_historial";

@Module({
  namespaced: true,
  name: "alegacionModule",
  store,
  dynamic: true,
})
class alegacionModule extends VuexModule {
  public alegaciones: alegacion[] = [];
  public alegacion: alegacion = new alegacion();
  public alegaciones_historico: alegacion_historico[] = [];

  // Obtener alegaciones por lote
  @Action({ commit: "onGetAlegacionesHistorico" })
  public async getAlegacionesByLote(id_lote: number) {
    return await ssmHttpService.get(API.alegaciones + "/lote/" + id_lote);
  }
  // Obtener alegación individual
  @Action({ commit: "onGetAlegacion" })
  public async getAlegacionByIdMod(id: number) {
    return await ssmHttpService.get(API.alegaciones + "/id_modificacion/" + id);
  }

  // Obtener alegaciónes por fichaje
  @Action({ commit: "onGetAlegaciones" })
  public async getAlegacionByIdFichaje(id: number) {
    return await ssmHttpService.get(API.alegaciones + "/id_fichaje/" + id);
  }
  // Obtener alegación individual
  @Action({ commit: "onGetAlegacion" })
  public async getAlegacion(id: number) {
    return await ssmHttpService.get(API.alegaciones + "/" + id);
  }

  // Crear alegación
  @Action
  public async crearAlegacion(model: alegacion) {
    return await ssmHttpService.post(API.alegaciones, model.toJson());
  }

  // Modificar alegación
  @Action
  public async modificarAlegacion(model: alegacion) {
    return await ssmHttpService.put(API.alegaciones + "/" + model.id, model);
  }

  // Eliminar alegación
  @Action
  public async eliminarAlegacion(model: alegacion) {
    return await ssmHttpService.delete(
      API.alegaciones + "/" + model.id,
      null,
      false
    );
  }

  // Mutaciones
  @Mutation
  public onGetAlegaciones(res: alegacion[]) {
    this.alegaciones = res
      ? res.map(function(x) {
          return new alegacion(x);
        })
      : [];
  }

  @Mutation
  public onGetAlegacion(res: alegacion) {
    this.alegacion = new alegacion(res);
  }

  @Mutation
  public onGetAlegacionesHistorico(res: alegacion_historico[]) {
    this.alegaciones_historico = res
      ? res.map(function(x) {
          var item = new alegacion_historico(x);
          item.modificaciones_hist = new fichajes_empleado_historial(
            x.modificaciones_hist
          );
          return item;
        })
      : [];
  }
}

export default getModule(alegacionModule);
